module.exports = __webpack_public_path__ + "static/media/YF102_3.3a035676.jpg";